<div class="edit-field-search-selector" [formGroup]="fieldParameters.sectionsContainer.formGroup">
  <ul class="edit-field-search-selector__selected-options">
    <li *ngIf="fieldParameters.object[fieldParameters.field.name]"
        class="edit-field-search-selector__selected-option bold">
      <span class="edit-field-search-selector__selected-option-text">
        <app-object-icon
          [object]="{artifact_id: fieldParameters.object[fieldParameters.field.name]}"></app-object-icon>
        <span>{{fieldParameters.sectionsContainer.formGroup.controls[formControlName].value}}</span>
      </span>
    </li>

    <li>
      <button mat-stroked-button
              color="primary"
              type="button"
              (click)="clickEnableSelector()"
              (keypress)="($event.key === 'Enter') && clickEnableSelector()">

        <span *ngIf="!fieldParameters.object[fieldParameters.field.name]">
          <i class="icon-select1"></i>
          <span class="bold uppercase" translate="TRANS__FIELD__ARRAY_ADD"></span>
          <span>&nbsp;</span>
          <span class="bold uppercase">{{fieldParameters.field.title | translate}}</span></span>

        <span *ngIf="fieldParameters.object[fieldParameters.field.name]">
          <i class="icon-edit-alternative"></i>
          <span class="bold uppercase" translate="TRANS__FIELD__ARRAY_CHANGE"></span>
          <span>&nbsp;</span>
          <span class="bold uppercase">{{fieldParameters.field.title | translate}}</span></span>
      </button>
    </li>
  </ul>
</div>
